"use strict";

var parseInvitations = require('./parseInvitations');

var parseResponse = require('./parseResponse');

var parseEnclosures = require('./parseEnclosures');

var parseWrappers = require('./parseWrappers');

var parseWaxSeals = require('./parseWaxSeals');

var parseVellumJackets = require('./parseVellumJackets');

function ClassicInvitationSuite(params) {
  parseInvitations.call(this, params);
  parseResponse.call(this, params);
  parseEnclosures.call(this, params);
  parseWrappers.call(this, params, 'thick');
  parseWaxSeals.call(this, params);
  parseVellumJackets.call(this, params);
}

module.exports = ClassicInvitationSuite;